import {
  image_default
} from "./chunk-TTVV4BNO.mjs";
export {
  image_default as Image
};
